import React from 'react'

import { MatchProductsButton } from './MatchProductsButton'
import { MatchButtonProps } from './MatchOzonToMoySkladButton'

import { useLogic } from '../hooks/storeHook'

import { WbProductProp } from '../server/mpsklad_core/Models/WbProductProp'
import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

export const wbMatchingProps = [
  [WbProductProp.ChrtId, 'Код товара (chrtId)'],
  [WbProductProp.SupplierArticle, 'Артикул поставщика'],
  [WbProductProp.Barcode, 'Штрихкод'],
  [WbProductProp.Name, 'Название']
] as const

export const MatchWbToMoySkladButton =
  (props: MatchButtonProps) => {
    const logic = useLogic()

    return (
      <MatchProductsButton
        {...props}
        fromIntegrationType={IntegrationType.Wildberries}
        fromProps={wbMatchingProps}
        submit={logic.matchWbToMoySkladProducts}
      />
    )
  }